import { Alert, AlertTitle, Button } from '@mui/material';
import { isAxiosError } from 'axios';
import { HttpError, useListContext, useTranslate } from 'react-admin';

import { LIVE_LOGS_I18N } from './liveLogs';

/** getList rejects with the raw axios error; an HttpError is read too, in case a caller wraps it. */
const errorStatus = (error: unknown): number | undefined => {
  if (isAxiosError(error)) {
    return error.response?.status;
  }
  return error instanceof HttpError ? error.status : undefined;
};

/** Replaces the grid only; the toolbar and the sub-tabs stay. */
export const LiveLogsError = () => {
  const { error, refetch } = useListContext();
  const translate = useTranslate();
  const status = errorStatus(error);

  const retry = (
    <Button size="small" onClick={() => refetch()}>
      {translate(`${LIVE_LOGS_I18N}.try_again`)}
    </Button>
  );

  if (status === 503) {
    return (
      <Alert severity="warning" action={retry}>
        <AlertTitle>{translate(`${LIVE_LOGS_I18N}.unavailable.title`)}</AlertTitle>
        {translate(`${LIVE_LOGS_I18N}.unavailable.body`)}
      </Alert>
    );
  }

  return (
    <Alert severity="error" action={retry}>
      {status === undefined
        ? translate(`${LIVE_LOGS_I18N}.error_unknown`)
        : translate(`${LIVE_LOGS_I18N}.error`, { status })}
    </Alert>
  );
};
